import React, { useState, useEffect, useMemo } from "react";
import RightIcon from "../../../../assests/images/Group 911.svg";
import PubNub from "pubnub";
import constants from "../../../../utils/constants";
import DisabledByDefaultIcon from "@mui/icons-material/DisabledByDefault";

const CHANNEL = "shopify-notify";

const ShopifySuccess = () => {
  const [isSuccess, setIsSuccess] = useState(null);

  const pubNub = useMemo(() => {
        return new PubNub({
            publishKey: constants.PUBNUB_PUBLISHKEY,
            subscribeKey: constants.PUBNUB_SUBSCRIBEKEY,
            uuid: constants.PUBNUB_UUID,
            autoNetworkDetection: true, 
            restore: true,
        });
    }, []);
  
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const status = params.get("status");
    const reason = params.get("reason");
    const isOk = status === "success";

    setIsSuccess(isOk);

    pubNub.publish({
        channel: CHANNEL,
      message: {
        type: status === "error" ? "SHOPIFY_FAILED" : "SHOPIFY_SUCCESS",
        reason: reason || null,
        time: Date.now(),
      },
    });

    let closeTimer;

    if (isOk) {
      try {
        if (window.opener && !window.opener.closed) {
          window.opener.postMessage(
            { type: "SHOPIFY_VERIFIED", status: "success" },
            "*",
          );
        }
      } catch (e) {}

      closeTimer = setTimeout(() => {
        try {
          window.close();
        } catch (e) {}
      }, 2000);
    }

    return () => {
      if (closeTimer) clearTimeout(closeTimer);
    };
  }, [pubNub]);

  if (isSuccess === null) return null;

  return (
    <div
      style={{
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
        fontFamily: "Arial",
        background: "#f9f9f9",
      }}
    >

      {isSuccess ? (
        <img
          src={RightIcon}
          alt="success"
          width="80"
          style={{ marginBottom: 20 }}
        />
      ) : (
        <DisabledByDefaultIcon
          style={{
            fontSize: 80,
            color: "#ff0000ff",
            marginBottom: 20,
          }}
        />
      )}

      <h2>
        {isSuccess
          ? "Shopify Verified Successfully"
          : "Shopify configuration failed. Please verify the shop name in your Profile page and try again!"}
      </h2>

      <p>
        {isSuccess
       ? "This window will close automatically..." : 
       ""}
      </p>
    </div>
  );
};

export default ShopifySuccess;
